import React, { useEffect, useState } from "react";
import Axios from "../../axios/axios";
import { Link, useNavigate } from "react-router-dom";
import { keyboard } from "@testing-library/user-event/dist/keyboard";
import Pagination from "../Pagination/Pagination";
import ConfirmationModal from "../utils/ConfirmationModal";
export default function BrandList() {
  const [brands, setBrands] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [perPage] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
const [showModal, setShowModal] = useState(false);
const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    getBrand();
  }, [page, keyword]);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  const getBrand = async () => {
    let data = await Axios.get(
      `/api/brand?pageNumber=${page}&pageSize=${pageSize}&keyword=${keyword}`
    );
    setBrands(data.data.brands);
    setTotalCount(data.data.count);
  };

 const deleteHandler = (id) => {
  setSelectedId(id);
  setShowModal(true);
};
const confirmDelete = async () => {
  try {
    const { data } = await Axios.delete(`/api/brand/${selectedId}`);
    if (data.message === "brand removed") {
      setShowModal(false);
      // Refresh list instead of full reload
      getBrand();
    }
  } catch (error) {
    console.error("Delete failed", error);
    setShowModal(false);
  }
};


  return (
    <div className="container">
      <div class="row">
        <div class="col-lg-12 ">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h4 class="card-title">Brand List</h4>

                <Link to="/brand/create">
                  <button type="button" class="btn btn-primary btn-md btn-md">
                    <i class="icon-plus menu-icon"></i>
                    Create
                  </button>
                </Link>
              </div>

              <div className="mb-3 d-flex justify-content-between">
                <input
                  type="text"
                  placeholder="Search  by brandname"
                  className="form-control w-25"
                  value={keyword}
                  onChange={(e) => {
                    setKeyword(e.target.value);
                    setPage(1); // Reset to first page on new filter
                  }}
                />
              </div>

              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Sl No</th>
                      <th>Brand Name</th>
                      <th>Title</th>
                    </tr>
                  </thead>
                  <tbody>
                    {brands.map((data, index) => (
                      <tr>
                        <td>{(page - 1) * pageSize + index + 1}</td>
                        <td>{data?.brandName}</td>
                        <td
                          style={{
                            maxWidth: "300px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {data?.title}
                        </td>

                        <td>
                          <div class="d-flex flex-wrap">
                            {/* <div class="p-2"> */}{" "}
                            <Link to={`/brand/update/${data?._id}`}>
                              <button
                                type="button"
                                className="btn btn-outline-dark btn-sm"
                              >
                                Edit
                              </button>
                            </Link>
                            {/* </div> */}
                            <div class="p-2">
                              {" "}
                             <button
  type="button"
  className="btn btn-outline-danger btn-sm mb-2"
  onClick={() => deleteHandler(data?._id)}
>
  Delete
</button>

                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {brands.length === 0 && (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No brands found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <Pagination
                  page={page}
                  perPage={perPage}
                  setPage={setPage}
                  totalCount={totalCount}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
  show={showModal}
  onHide={() => setShowModal(false)}
  onConfirm={confirmDelete}
  title="Delete Brand"
  message="Are you sure you want to delete this brand? This action cannot be undone."
/>

    </div>
  );
}
